import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import type { TOffer } from 'shared/types/TRankingService';

export const isMplPreApprovalOffer = (offer: TOffer | MPLPreApprovalOffer): offer is MPLPreApprovalOffer => {
  return offer.type === 'preApprovalsOffer';
};
